import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc chi tiết công
export function locChiTietCong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/chi-tiet/', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết công
export function layChiTietCong(id: number) {
  try {
    return axiosApi.get('/cham-cong/chi-tiet/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật chi tiết công
export function capNhatChiTietCong(id: number, params: any) {
  try {
    return axiosApi.put('/cham-cong/chi-tiet/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết công nhân viên
export function layChiTietCongNhanVien(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/chi-tiet/nhan-vien/' + userId, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tính toán chi tiết công
export function tinhToanChiTietCong(params: any) {
  try {
    return axiosApi.post('/cham-cong/chi-tiet/tinh-toan', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
